import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const HeroSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);
  return <>
      <section className="relative w-full bg-black min-h-[100vh] py-12 overflow-hidden" data-id="element-89">
        {/* Animated Gradient Background */}
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden" data-id="element-90">
          <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#0f0f0a] to-[#000000] animate-gradient-shift" data-id="element-91">
            <div className="absolute inset-0 opacity-30" data-id="element-92">
              <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_#ffdf07_0%,_transparent_60%)] animate-float-light-1" data-id="element-93"></div>
              <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,_#D4AF37_0%,_transparent_60%)] animate-float-light-2" data-id="element-94"></div>
              <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-95"></div>
            </div>
          </div>
          <div className="absolute inset-0 bg-black bg-opacity-40 z-10" data-id="element-96"></div>
        </div>
        {/* Content */}
        <div className="relative z-20 w-full mx-auto py-8 px-4 sm:px-6 md:px-8 flex flex-col justify-center min-h-[90vh]" data-id="element-97">
          <div className="max-w-4xl mx-auto text-center" data-id="element-98">
            {/* Logo */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7
          }} className="mb-6" data-id="element-99">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-24 sm:w-28 md:w-32" data-id="element-100" />
            </motion.div>
            {/* Small Headline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.2
          }} className="text-[#ffdf07] text-sm sm:text-base md:text-lg font-semibold mb-4 libre-caslon-text-regular" data-id="element-101">
              For Healthcare Clinics Doing $3M–$25M+/Yr...
            </motion.p>
            {/* Main Headline */}
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.3
          }} className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-6 typekit-heading leading-tight px-2" data-id="element-102">
              Learn The Scaling Cheat Code Clinic Owners Use to Secure a{' '}
              <span className="relative inline-block" data-id="element-103">
                <span className="relative z-10 px-2 text-black font-bold" data-id="element-104">
                  Multi 8-Figure Payday
                </span>
                <span className="absolute inset-0 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] animate-wipe-in animation-delay-500 rounded-md shadow-[0_4px_14px_rgba(255,223,7,0.25)] z-0" data-id="element-105"></span>
              </span>
            </motion.h1>
            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.4
          }} className="libre-caslon-text-regular text-base sm:text-lg text-white mb-8 leading-relaxed px-2" data-id="element-106">
              Step 1: Tap play on the video below to learn how to avoid creating a business that never becomes an asset.
            </motion.p>
            {/* Wistia Video Player */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.6
          }} className="max-w-sm sm:max-w-md md:max-w-xl lg:max-w-3xl mx-auto mb-8" data-id="element-107">
              <div className="relative shadow-2xl rounded-lg overflow-hidden" data-id="element-108">
                <wistia-player media-id="9ccnfz42p2" aspect="1.7777777777777777" data-id="element-109"></wistia-player>
              </div>
            </motion.div>
            {/* Step 2 Text */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.7
          }} className="mb-2" data-id="element-110">
              <p className="libre-caslon-text-regular text-base sm:text-lg text-white leading-relaxed px-2" data-id="element-111">
                Step 2: Fill out the short application and book a call
              </p>
              <p className="libre-caslon-text-regular text-xs sm:text-sm text-gray-400 mt-2 px-2 opacity-60" data-id="element-112">
                Application May Take a Few Moments to Load
              </p>
            </motion.div>
            {/* Apply button with border light effect */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.8
          }} className="flex justify-center mb-4 mt-6" data-id="element-113">
              <div className="relative" data-id="element-114">
                <div className="button-border-light" data-id="element-115"></div>
                <motion.button onClick={() => setIsModalOpen(true)} whileHover={{
                scale: 1.05,
                boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
              }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-8 sm:px-10 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-116">
                  Apply for the MRI Now
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Modal */}
      <AnimatePresence data-id="element-117">
        {isModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90" onClick={() => setIsModalOpen(false)} data-id="element-118">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="relative w-full max-w-4xl h-[90vh] bg-white rounded-lg shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-119">
              <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 transition-colors" data-id="element-120">
                <XIcon size={24} data-id="element-121" />
              </button>
              <iframe src="https://form.typeform.com/to/Z4eXKwXk" className="w-full h-full" frameBorder="0" title="Application Form" data-id="element-122" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};
export default HeroSection;